import React from 'react';

const TemplateModal = ({
  showModal,
  setShowModal,
  templateModalType,
  editingTemplate,
  setEditingTemplate,
  templateForm,
  setTemplateForm,
  handleSaveTemplate,
  loading
}) => {
  if (!showModal) return null;

  const isEditMode = Boolean(editingTemplate && editingTemplate.type === templateModalType);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <h3 className="text-xl font-semibold mb-4">
          {isEditMode ? 'Duzenle' : 'Yeni'} {templateModalType === 'email' ? 'Email' : 'SMS'} Sablonu
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Sablon Adi
            </label>
            <input
              type="text"
              value={templateForm.name}
              onChange={(e) => setTemplateForm({ ...templateForm, name: e.target.value })}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Sablon adini girin..."
            />
          </div>

          {templateModalType === 'email' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Konusu
              </label>
              <input
                type="text"
                value={templateForm.subject}
                onChange={(e) => setTemplateForm({ ...templateForm, subject: e.target.value })}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="Email konusunu girin..."
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {templateModalType === 'email' ? 'Email Icerigi' : 'SMS Mesaji'}
            </label>
            <textarea
              value={templateModalType === 'email' ? templateForm.body : templateForm.content}
              onChange={(e) => setTemplateForm({
                ...templateForm,
                [templateModalType === 'email' ? 'body' : 'content']: e.target.value
              })}
              rows={8}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder={templateModalType === 'email' ? 'Email icerigini girin...' : 'SMS mesajini girin...'}
            />
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800 font-medium mb-2">Kullanilabilir Degiskenler:</p>
            <p className="text-xs text-blue-700">
              {'{{name}}'} - Ogrenci adi<br />
              {'{{parent_name}}'} - Veli adi<br />
              {'{{city}}'} - Sehir<br />
              {'{{class_type}}'} - Sinif
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={() => {
              setShowModal(false);
              setEditingTemplate(null);
              setTemplateForm({ name: '', subject: '', body: '', content: '' });
            }}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Iptal
          </button>
          <button
            onClick={handleSaveTemplate}
            disabled={loading || !templateForm.name || (templateModalType === 'email' && !templateForm.subject)}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Kaydediliyor...' : isEditMode ? 'Guncelle' : 'Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateModal;
